<template>
  <div v-if="valuesTemp && valuesTemp.length > 0">
    <select
      class="mb-2"
      :id="`klaus_${formItem.name}`"
      v-model="values.equalDays"
      :disabled="disabled"
    >
      <option
        v-for="option in formItem.options"
        :key="option.value"
        :value="option.value"
        >{{ `${option.label}` }}</option
      >
    </select>
    <div v-if="!values.equalDays">
      <div
        class="row schedule-days my-4"
        v-for="value in valuesTemp"
        :key="value.day"
      >
        <div class="col-4 d-flex align-items-center ">
          <p class="my-0 open-sans-regular text-rem-0-6 text-grey-dark">
            {{ getDayESP(value.day) }}
          </p>

          <input
            class="ml-auto"
            type="checkbox"
            v-model="value.active"
            :disabled="disabled"
          />
        </div>
        <div v-if="value.active" class="col-8 d-flex align-items-center">
          <vue-timepicker
            format="h:mm a"
            minute-interval="15"
            class="time-picker-right"
            hide-clear-button
            v-model="value.from"
            :disabled="disabled"
          ></vue-timepicker>
          <p class="my-0 mx-2 open-sans-regular text-rem-0-7 text-grey-dark ">
            hasta
          </p>
          <vue-timepicker
            format="h:mm a"
            minute-interval="15"
            class="time-picker-left"
            hide-clear-button
            v-model="value.to"
            :disabled="disabled"
          ></vue-timepicker>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row mt-1 justify-content-center">
        <div class="col-6">
          <vue-timepicker
            format="h:mm a"
            hide-clear-button
            class="time-picker-right"
            v-model="valuesTemp[0].from"
            :disabled="disabled"
          ></vue-timepicker>
        </div>
        <div class="col-6">
          <vue-timepicker
            format="h:mm a"
            hide-clear-button
            class="time-picker-left"
            v-model="valuesTemp[0].to"
            :disabled="disabled"
          ></vue-timepicker>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue"
import moment from "moment"
export default {
  props: ["values", "formItem", "disabled"],
  components: {
    VueTimepicker,
  },
  mounted() {
    this.setTempValue()
  },
  data() {
    return {
      equalDays: false,
      valuesTemp: [],
    }
  },
  methods: {
    saveSchedule() {
      let tempRe = this.valuesTemp.map(value => {
        const newObjet = Object.assign({}, value, {
          to: moment(value.to, ["h:mm A"]).format("HH:mm"),
          from: moment(value.from, ["h:mm A"]).format("HH:mm"),
        })

        return newObjet
      })
      console.log("BEFORE SAVE", tempRe)
      return tempRe
    },
    setTempValue() {
      console.log("VALIES METHOD", this.values)
      let temp = Array.from(this.values.value).map(value => {
        const newObjet = Object.assign({}, value, {
          to: moment(value.to, "HH:mm").format("h:mm a"),
          from: moment(value.from, "HH:mm").format("h:mm a"),
        })
        console.log("NEW OBJECT", newObjet)
        return newObjet
      })
      console.log("ALL OBJECT", temp)
      this.valuesTemp = temp
      this.equalDays = this.values.equalDays
    },

    changeEqualDays(event) {
      this.$emit("onScheduleChange", event.target.value)
      this.equalDays = event.target.value
    },
    getDayESP(day) {
      switch (day) {
        case "monday":
          return "LUNES"
        case "tuesday":
          return "MARTES"
        case "wednesday":
          return "MIERCOLES"
        case "thursday":
          return "JUEVES"
        case "friday":
          return "VIERNES"
        case "saturday":
          return "SABADO"
        case "sunday":
          return "DOMINGO"
        default:
          return day
      }
    },
  },
}
</script>

<style lang="scss">
.time-picker-left {
  .dropdown {
    right: 0;
    left: auto;
  }
}
.time-picker-right {
  .dropdown {
    left: 0;
    right: auto;
  }
}
.schedule-days {
  min-height: 43.1px;
}
</style>
